<!-- 字典查询 -->
<template>
  <div id='dictTypeManage'>
    <!--查询条件-->
    <div class="search-form">
      <el-form inline :model="originData" ref="searchForm">
        <el-form-item label="更新时间" prop="dictTypeName">
          <el-date-picker type="date" v-model="originData.updateTimeStart" placeholder="起始日期"/>
          <span style="margin:auto 10px;color:#999999">至</span>
          <el-date-picker type="date" v-model="originData.updateTimeEnd" placeholder="结束日期"/>
        </el-form-item>
        <el-form-item label="字典类别名称" prop="dictTypeName">
          <el-input placeholder="请输入" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.dictTypeName"/>
        </el-form-item>
        <el-form-item label="字典类别标识" prop="dictTypeIdentif">
          <el-input placeholder="请输入" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.dictTypeIdentif"/>
        </el-form-item>
        <el-form-item label="归属模块" prop="moduleType">
          <el-select v-model.trim="originData.moduleType">
            <el-option
              v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
            <el-option label="全部" value="" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click='search()'
        >查询</el-button>
        <el-button
          size="small"
          @click='rest()'
        >重置</el-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click='addInfo()'
          v-if="judgeJurisdiction(
          '413115316123422720')"
        >新增字典类别</yh-button>
      </div>
    </div>
    <!--字典列表-->
    <div class="user_table">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          label="字典类别ID"
          prop='id'
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.id}}
          </template>
        </el-table-column>
        <el-table-column
          label="字典类别名称"
          width="200"
        >
          <template slot-scope="scope">
            <span
              v-if="functionList.indexOf(
          '322545212274216960')!='-1'"
              class='productDecoration'
              @click='findDictDetail(scope.row)'
              v-html='scope.row.dictTypeName'
            >
            </span>
            <span
              v-else
              v-html='scope.row.dictTypeName'
            >
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="dictTypeIdentif"
          width="200"
          label="字典类别标识"
        >
        </el-table-column>
        <el-table-column
          width="300"
          label="描述"
        >
        <template slot-scope="scope">
          {{scope.row.dictTypeComment | emptyCheckFilter}}
        </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="dictNumber"
          label="字典项个数"
        >
        </el-table-column>
        <el-table-column
          width="200"
          prop="moduleName"
          label="归属模块"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="200"
        >
          <template slot-scope="scope">
            {{scope.row.updateTime | formatTime}}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateUser"
          label="更新人ID"
          width="200"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <div class="feature-container">
              <span
                class="button--blue"
                @click="modify(scope.row)"
                type="primary"
                v-if="judgeJurisdiction(
          '412781385905819648')"
              >修改</span>
              <span
                class="button--blue"
                @click='findDictDetail(scope.row)'
                type="danger"
                v-if="judgeJurisdiction('412812201851572224')"
              >查看字典项</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
    <!--新增-->
    <yh-dialog title="新增字典类别" :visible.sync="newdic">
      <el-form
        class="hide-error"
        :model="insertDictType"
        label-width="110px"
      >
        <el-form-item
          label="字典类别名称"
          prop="dictTypeName"
          required
        >
          <el-input
            v-model="insertDictType.dictTypeName"
            placeholder="请输入字典类别名称，不能超过20字"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典类别标识"
          prop="dictTypeIdentif"
          required
        >
          <el-input
            v-model="insertDictType.dictTypeIdentif"
            placeholder="请输入字典类别标识，不能超过40字"
            maxlength="40"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="归属模块"
          prop="moduleType"
          required
        >
          <el-select v-model.trim="insertDictType.moduleType" class="search-ipt">
            <el-option v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
          </el-select>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="dictTypeComment"
        >
          <el-input
            type="textarea"
            v-model="insertDictType.dictTypeComment"
            placeholder="请输入描述，不超过200字"
            maxlength="200"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="newdic = false">取消</el-button>
        <yh-button
          type="primary"
          :loading="newAddLoadingFlag"
          @click="insertDictTypeClick()"
        >提交</yh-button>
      </span>

    </yh-dialog>
    <!--修改-->
    <yh-dialog title="修改字典类别" :visible.sync="modifyDic">
      <el-form
        class="hide-error"
        :model="updateDictType"
        label-width="110px"
      >
        <el-form-item
          label="字典类别名称"
          prop="dictTypeName"
          required
        >
          <el-input
            v-model="updateDictType.dictTypeName"
            placeholder="请输入字典类别名称，不能超过20字"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="字典类别标识"
          prop="dictTypeIdentif"
        >
          <el-input
            v-model="updateDictType.dictTypeIdentif"
            placeholder="请输入字典类别标识，不能超过40字"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="归属模块"
          prop="moduleType"
          required
        >
          <el-select v-model.trim="updateDictType.moduleType" class="search-ipt">
            <el-option v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
          </el-select>
        </el-form-item>
        <el-form-item
          label="描述"
          prop="dictTypeComment"
        >
          <el-input
            type="textarea"
            maxlength="200"
            v-model="updateDictType.dictTypeComment"
            placeholder="请输入描述，不超过200字"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="modifyDic = false">取消</el-button>
        <el-button
          type="primary"
          :loading="newUptLoadingFlag"
          @click="handleUpdateDictTypeClick()"
        >保存</el-button>
      </span>
    </yh-dialog>
  </div>
</template>
<script>
import { getFunctionList, addNav, getPagingData } from '@/mixins';

export default {
  name: 'DictionaryManagement',
  mixins: [getFunctionList, addNav, getPagingData],
  data() {
    return {
      emptyText: this.$LS.empty,
      // 初始数据
      originData: {
        dictTypeName: '',
        dictTypeIdentif: '',
        updateTimeStart: '',
        updateTimeEnd: '',
        moduleType: '',
      },
      // 查询数据
      searchParam: {
        dictTypeName: '',
        dictTypeIdentif: '',
        updateTimeStart: '',
        updateTimeEnd: '',
        moduleType: '',
      },
      insertDictType: {
        dictTypeName: '',
        dictTypeIdentif: '',
        moduleType: 'commonModule',
        dictTypeComment: '',
      },
      updateDictType: {
        id: '',
        dictTypeName: '',
        dictTypeIdentif: '',
        moduleType: '',
        dictTypeComment: '',
      },
      newdic: false,
      modifyDic: false,
      functionList: [],
      menuData: [],
      pageNo: 1,
      currentPage: 1,
      sumCount: 0,
      pageSize: 10,
      tableData: [], // 表格数据
      dictTypeName: '',
      dictTypeCode: '',
      status: '',
      // 新增字典类别按钮loading标记
      newAddLoadingFlag: false,
      // 修改字典类别按钮loading标记
      newUptLoadingFlag: false,
      // 模块列表
      moduleData: [],
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData(true);
        this.getModuleList();
      },
    },
  },
  mounted() {
    const token = this.$route.query.userToken;
    const sessionData = JSON.parse(this.$route.query.sessionData);
    sessionStorage.setItem('userToken', JSON.stringify(token));
    sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
    this.getJurisdiction();
  },
  methods: {
    // 获取功能权限
    getJurisdiction() {
      const params = {
        data: {
          roleId: JSON.parse(sessionStorage.getItem('sessionData')).roleId,
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          token: JSON.parse(sessionStorage.getItem('userToken')),
        },
      };
      this.$_post(this.$API.get_role_menu, params).then((res) => {
        console.log(res);
        this.functionList = res.data.roleMenuList;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 判断是否有权限
    judgeJurisdiction(v) {
      for (let index = 0; index < this.functionList.length; index++) {
        if (this.functionList[index].menuId === v) {
          return true;
        }
      }
      return false;
    },
    // 获取表格数据
    getTableData(emptyValue) {
      this.getPagingData(this.$API.getDictTypeList, emptyValue);
    },
    // 查询按钮
    search() {
      this.searchParam = { ...this.originData };
      this.currentPage = 1;
      this.pageNo = 1;
      this.getTableData();
    },
    // 重置按钮
    rest() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 模块查询
    getModuleList() {
      const params = {};
      this.$_post(this.$API.getModuleList, params).then((res) => {
        this.moduleData = res.data.list;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 新增和修改时校验规则
    checkFormData(handleName) {
      function lengthCheck(n) {
        return v => v.length <= n;
      }
      const rules = [
        {
          prop: 'dictTypeName',
          message: '请输入字典类别名称',
          validations: [
            {
              message: '字典类别名称不能超过20个字符',
              validate: lengthCheck(20),
            },
          ],
        },
        {
          prop: 'dictTypeIdentif',
          message: '请输入字典类别标识',
          validations: [
            {
              message: this.$MSG.M0074,
              validate: lengthCheck(40),
            },
          ],
        },
        {
          prop: 'moduleType',
          message: '请选择归属模块',
        },
        {
          prop: 'dictTypeComment',
          required: false,
          validations: [
            {
              message: '描述不能超过200个字符',
              validate: lengthCheck(200),
            },
          ],
        },
      ];
      return this.validate(rules, this[handleName]);
    },
    // 点击新增
    addInfo() {
      this.newdic = true;
      Object.keys(this.insertDictType).forEach((key) => {
        this.insertDictType[key] = '';
      });
      // 归属模块默认为公共模块
      this.insertDictType.moduleType = 'commonModule';
    },
    // 新增校验
    insertDictTypeClick() {
      if (!this.checkFormData('insertDictType')) {
        return;
      }
      this.newAddLoadingFlag = true;
      this.$_yh_confirm(
        '字典类别新增后将无法删除，确定要新增吗？',
        '新增字典类别',

      ).then(() => {
        const userid = JSON.parse(sessionStorage.getItem('sessionData')).userId;
        const params = {
          data: {
            dictTypeName: this.insertDictType.dictTypeName,
            dictTypeIdentif: this.insertDictType.dictTypeIdentif,
            dictTypeComment: this.insertDictType.dictTypeComment,
            moduleType: this.insertDictType.moduleType,
            updateUser: userid,
            createUser: userid,
          },
        };
        this.addDictType(params);
      }).catch(() => {
        this.newAddLoadingFlag = false;
      });
    },
    // 新增确定
    addDictType(params) {
      return this.$_post(this.$API.addDictTypeDetail, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.newdic = false;
          this.$message.success(this.$MSG.M0031);
          this.getTableData();
        } else {
          this.$message.warning(res.errorMsg);
        }
        this.newAddLoadingFlag = false;
      });
    },
    // 点击修改
    modify(row) {
      this.modifyDic = true;
      this.updateDictType = JSON.parse(JSON.stringify(row));
    },
    // 修改校验
    handleUpdateDictTypeClick() {
      if (!this.checkFormData('updateDictType')) {
        return;
      }
      this.newUptLoadingFlag = true;
      this.$_yh_confirm(
        `确认要修改"${this.updateDictType.dictTypeIdentif}"的字典类别信息吗？`,
        '修改字典类别',
      ).then(() => {
        console.log(this.updateDictType, 'this.updateDictType');
        const userid = JSON.parse(sessionStorage.getItem('sessionData')).userId;
        const params = {
          data: {
            id: this.updateDictType.id,
            dictTypeName: this.updateDictType.dictTypeName,
            dictTypeIdentif: this.updateDictType.dictTypeIdentif,
            dictTypeComment: this.updateDictType.dictTypeComment,
            moduleType: this.updateDictType.moduleType,
            updateUser: userid,
          },
        };
        this.updateDict(params);
      }).catch(() => {
        this.newUptLoadingFlag = false;
      });
    },
    // 修改确定
    updateDict(params) {
      return this.$_post(this.$API.editDictTypeDetail, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.modifyDic = false;
          this.$message.success(this.$MSG.M0031);
          this.getTableData();
        } else {
          this.$message.warning(res.errorMsg);
        }
        this.newUptLoadingFlag = false;
      });
    },
    // 字典项详情
    findDictDetail(row) {
      this.dictTypeName = '';
      this.dictTypeCode = '';
      sessionStorage.setItem('dictTypeDetail', JSON.stringify(row));
      // this.addNav({
      //   name: '字典项列表',
      //   path: '/dict-configurationTwo',
      // });
      this.$router.push({
        path: '/dict-configurationTwo',
        query: {
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/button.scss";
#dictTypeManage {
  overflow: initial;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.el-row {
  text-align: center;
}
.el-col {
  margin-top: 10px;
}
.productDecoration {
  border-bottom: 1px solid #1e88ff;
  color: #1e88ff;
  cursor: pointer;
}
</style>
